var SiteHeaderController = (function () {
    function SiteHeaderController(env, $window, $state, $scope, $element) {
        this.env = env;
        this.$window = $window;
        this.$state = $state;
        this.$scope = $scope;
        this.$element = $element;
        this.disableLink = true;
    }
    SiteHeaderController.prototype.getQueue = function (queryId) {
        this.$state.go('queue', {
            id: queryId
        });
    };
    SiteHeaderController.prototype.getSamplingQueue = function () {
        this.$state.go('queueSampling');
    };
    SiteHeaderController.prototype.getQueueManualReview = function () {
        this.$state.go('queueManualReview');
    };
    SiteHeaderController.prototype.setAside = function () {
        this.$state.go('queueSetAside');
    };
    SiteHeaderController.prototype.errorQueue = function () {
        this.$state.go('queueError');
    };
    SiteHeaderController.prototype.generalErrorQueue = function () {
        this.$state.go('queueErrorGeneral');
    };
    SiteHeaderController.prototype.sapMissingQueue = function () {
        this.$state.go('queueSapMissing');
    };
    SiteHeaderController.$inject = ['env', '$window', '$state', '$scope', '$element'];
    return SiteHeaderController;
}());
var SiteHeaderComponent = (function () {
    function SiteHeaderComponent() {
        this.templateUrl = 'site-header.html';
        this.controllerAs = 'vm';
        this.controller = SiteHeaderController;
    }
    return SiteHeaderComponent;
}());
angular
    .module('application')
    .component('header', new SiteHeaderComponent());

//# sourceMappingURL=site.header.component.js.map
